/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 9 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import { IoCallOutline, IoCheckmark, IoChevronDown } from 'react-icons/io5';
import { LuChevronRight, LuPlus } from 'react-icons/lu';
import AddPatient from '../DocAppointment/AddPatient';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import dayjs from 'dayjs';
import { showToast } from '../../showTost';
import { FiMapPin, FiPlus } from 'react-icons/fi';
import { TiLocation } from "react-icons/ti";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import Payment from '../../Payment/Payment';
import { MyContext } from '../../Context/MyProvider';
import DeleteIcon from "../../assets/Icon/delete.svg";
import calendar from "../../assets/Icon/calendar.svg";
import clock from "../../assets/Icon/clock-circle.svg";
import Wallet from "../../assets/Icon/wallet.svg";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';
const CartBooking = () => {

    const { t } = useTranslation();

    const today = dayjs();
    const { ApiBaseUrl, ImgBaseUrl, isPayment, setIsPayment, paymentStatus, setPaymentStatus, mapKey, setActivePage, transactionid } = useContext(MyContext);
    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const [labData, setLabData] = useState();
    const [loading, setLoading] = useState(true);
    const [isDriverSelected, setIsDriverSelected] = useState(false);
    const [isDriverSelected2, setIsDriverSelected2] = useState(false);
    const [packageData, setPackageData] = useState([]);
    const [familyData, setFamilyData] = useState([]);
    const [relationshipData, setRelationshipData] = useState([]);
    const [booldData, setBooldData] = useState([]);
    const [isPatient, setIsPatient] = useState(false);
    const [isShowDate, setIsShowDate] = useState(false);
    const [selectDate, setSelectDate] = useState("");
    const [SelectTime, setSelectTime] = useState("");
    const [openPicker, setOpenPicker] = useState(false);
    const [additionalNote, setAdditionalNote] = useState();
    const [myWallet, setMyWallet] = useState();
    const [myWallet2, setMyWallet2] = useState();
    const [wallet, setWallet] = useState();
    const [isCouponShow, setIsCouponShow] = useState(false);
    const [couponCode, setCouponCode] = useState();
    const [couponList, setCouponList] = useState([]);
    const [taxData, setTaxData] = useState("");
    const [showDeleteBox, setShowDeleteBox] = useState("");
    const [productData, setProductData] = useState([]);
    const [serviceTotal, setServiceTotal] = useState();
    const [TotalAmt, setTotalAmt] = useState();
    const [TotalAmt2, setTotalAmt2] = useState();
    const [commissionData, setCommissionData] = useState();
    const [homeExteraPrice, setHomeExteraPrice] = useState();
    const [isLocationShow, setIsLocationShow] = useState(false);
    const [isLocationShow2, setIsLocationShow2] = useState(false);
    const [addressList, setAddressList] = useState([]);
    const [latitude, setLatitude] = useState();
    const [longitude, setLongitude] = useState();
    const [value, setValue] = useState();
    const [addressData, setAddressData] = useState({ address: "", houseno: "", mobile: "", landmark: "", instruction: "", address_as: "" });
    const [selectAddress, setSelectAddress] = useState();
    const [allData, setAllData] = useState();
    const [deletetext, setDeleteText] = useState("");

    const navigate = useNavigate();

    const settings = {
        arrows: false,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
            { breakpoint: 770, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        ],
    };

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: mapKey
    });


    const toggleDriverSelection = () => setIsDriverSelected(prev => !prev);

    const LocalData = sessionStorage.getItem("Docprofile");
    if (LocalData) {
        var { Categoryid, Labid } = JSON.parse(LocalData);
    }

    useEffect(() => {

        navigator.geolocation.getCurrentPosition(position => {
            const lat = position.coords.latitude;
            const long = position.coords.longitude;
            setLatitude(lat);
            setLongitude(long);
        });

        HandleFatchData();
        axios.get(`${ApiBaseUrl}/customer/family_member_add_detail`)
            .then((res) => {
                const { relationship_list, blood_group_list } = res.data;
                setRelationshipData(relationship_list);
                setBooldData(blood_group_list);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";
    }, [loading]);

    const HandleFatchData = () => {

        setLoading(true);
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/package_cart`, { id: Userid, lab_id: Labid, category_id: Categoryid })
                .then((res) => {
                    // console.log("package_cart", res);
                    const { ResponseCode, lab, package_detail, family_member, wallet_amount, coupon, commission_data, home_extra_price } = res.data;
                    if (ResponseCode === 200) {
                        setLoading(false);
                        setHomeExteraPrice(home_extra_price);
                        setFamilyData(family_member);
                        setLabData(lab);
                        setPackageData(package_detail);
                        HandleFamilyP(package_detail, family_member);
                        setMyWallet(wallet_amount);
                        setCouponList(coupon);
                        setCommissionData(commission_data);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });

            axios.post(`${ApiBaseUrl}/customer/address_list`, { id: Userid })
                .then((res) => {
                    // console.log(res);
                    setAddressList(res.data.address_list);
                })
                .catch((error) => {
                    console.error(error);
                });
        }

    };
    const HandleFamilyP = (item, family_member) => {
        const AllData = [];

        for (let i = 0; i < item.length; i++) {
            const hasFamily = Array.isArray(family_member) && family_member.length > 0;
            AllData.push({
                pid: item[i].id,
                f: hasFamily ? [family_member[0].id] : "",
                total: hasFamily ? item[i].package_price : 0
            });
        }

        setProductData(AllData);
    };


    useEffect(() => {
        const Total = productData.reduce((sum, item) => sum + item.total, 0);
        setServiceTotal(Total);
    }, [productData]);

    useEffect(() => {
        const total = Number(taxData.Rate) + serviceTotal;
        setTotalAmt2(isDriverSelected2 ? total + homeExteraPrice : total);
        const TotalAmount = couponCode ? total - couponCode.amt : total;
        setTotalAmt(TotalAmount);
    }, [taxData, serviceTotal, couponCode]);

    useEffect(() => {
        const Total = isDriverSelected2 ? TotalAmt + homeExteraPrice : TotalAmt2;
        setTotalAmt(Total);
    }, [isDriverSelected2]);

    useEffect(() => {
        if (myWallet > TotalAmt) {
            const CouponTotal = couponCode ? TotalAmt2 - couponCode.amt : TotalAmt2;
            setTotalAmt(isDriverSelected ? 0 : CouponTotal);
            setWallet(isDriverSelected ? CouponTotal : 0);
        } else {
            const Total = isDriverSelected ? TotalAmt - myWallet : TotalAmt2;
            setTotalAmt(Total);
        }

        if (myWallet < TotalAmt) {
            setMyWallet2(isDriverSelected ? 0 : myWallet);
            setWallet(isDriverSelected ? myWallet : 0);
        } else {
            const MyTotal = isDriverSelected ? myWallet - TotalAmt : myWallet;
            setMyWallet2(MyTotal);
        }
    }, [isDriverSelected]);

    const HandleBook = (id) => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/add_cart`, { id: Userid, lab_id: Labid, package_id: id })
                .then((res) => {
                    // console.log(res);
                    if (res.data.ResponseCode === 200) {
                        HandleFatchData();
                        setShowDeleteBox("");
                        if (packageData.length === 1) {
                            navigate("/packages");
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    useEffect(() => {
        if (!commissionData) return;

        if (commissionData.commission_type === "fix") {
            setTaxData({ Rate: commissionData.commission, type: commissionData.commission_type });
        } else {
            const TaxRate = (serviceTotal / commissionData.commission);
            const TaxType = commissionData.commission + commissionData.commission_type;
            setTaxData({ Rate: TaxRate, type: TaxType });
        }

    }, [commissionData, serviceTotal]);


    const SelectPatientHandle = (patientid, price, id) => {
        if (isDriverSelected) {
            setIsDriverSelected(false);
        }

        const updatedData = productData.map(product => {
            if (product.pid === id) {
                const isAlreadySelected = product.f.includes(patientid);
                const updatedF = isAlreadySelected
                    ? product.f.filter(p => p !== patientid)
                    : [...product.f, patientid];
                const unitPrice = product.total || 0;
                const total = isAlreadySelected ? unitPrice - price : unitPrice + price;

                return { ...product, f: updatedF, total };
            }
            return product;
        });

        setProductData(updatedData);
    };

    const disablePastDates = (date) => {
        return date.isBefore(today, 'day');
    };

    const handleStartTimeChange = (newValue) => {
        setSelectTime(newValue.format('hh:mm A'));
    };

    const HandleCoupanAdd = (code, amt, id) => {
        setCouponCode({ code, amt, id });
        showToast({ title: t("Coupon Add Successful"), id: "success" });
        setIsCouponShow(false);
    };


    const HandleProceed = async () => {
        const hasMissingPatients = productData.some(item => item.f.length < 1);

        if (hasMissingPatients) {
            showToast({ title: t("Please Select Patients"), id: "error" });
            return;
        }

        if (!selectDate || !SelectTime) {
            showToast({ title: t("Please Select Date & Time"), id: "error" });
            return;
        }

        if (isDriverSelected2 && !selectAddress) {
            showToast({ title: t("Please Select Address"), id: "error" });
            return;
        }

        if (isDriverSelected && TotalAmt === 0) {
            HandleBooking();
        } else {
            setIsPayment(true);

            const Userid = secureLocalStorage.getItem("Userid");
            const TotalPrice = couponCode ? TotalAmt2 - couponCode.amt : TotalAmt2;

            const Data = {
                id: Userid,
                lab_id: Labid,
                category_id: Categoryid,
                date: selectDate.format('DD-MM-YYYY'),
                time: SelectTime,
                message: additionalNote ? additionalNote : "",
                address: isDriverSelected2 ? selectAddress.id : "",
                package_list: await HandlePackageListGet(),
                family_mem_id: await HandleGetMemberIds(),
                tot_package_price: await HandleGetPackagePrice(productData),
                tot_price: TotalPrice,
                home_extra_price: isDriverSelected2 ? homeExteraPrice : 0,
                coupon_id: couponCode ? couponCode.id : "",
                coupon_amount: couponCode ? couponCode.amt : 0,
                site_commission: taxData.Rate,
                wallet_amount: isDriverSelected ? wallet : 0,
                home_col_status: isDriverSelected2 ? 1 : 0
            };

            setAllData(Data);
            sessionStorage.setItem("page", "2");

        }
    };

    const HandleCoupanRemove = () => {
        if (couponCode) {
            setCouponCode("");
        } else {
            setIsCouponShow(true);
        }
        if (isDriverSelected) {
            setIsDriverSelected(!isDriverSelected);
        }
    };


    const HandlePackageListGet = async () => {
        return productData.map(({ pid, f }) => ({ pid, f }));
    };

    const HandleGetMemberIds = () => {
        const memberIds = [...new Set(productData.flatMap(item => item.f))];
        return memberIds;
    };


    const handleMapClick = (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setLatitude(lat);
        setLongitude(lng);
    };

    const HandleGetGoogleAddress = async (lat, lng) => {
        try {

            const response = await axios.get(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${mapKey}`
            );

            const address = response.data.results[0]?.formatted_address;
            // console.log('Address:', address);
            return address;
        } catch (error) {
            console.error('Error fetching address:', error);
        }
    };

    const HandleSaveAddress = async () => {

        HandleGetGoogleAddress(latitude, longitude);

        if (!addressData.address && !addressData.houseno && !addressData.landmark && !addressData.instruction && !addressData.address_as) {
            showToast({ title: t("Please Enter Details"), id: "error" });
            return;
        }

        if (!value) {
            showToast({ title: t("Please Enter Details"), id: "error" });
            return;
        }

        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid) {

            const formattedNumber = formatPhoneNumberIntl(value);
            const countryCode = formattedNumber.split(' ')[0];
            const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
            const cleanedNumber = numberWithoutCode.split(' ').join('');

            const Data = {
                id: Userid,
                house_no: addressData.houseno,
                address: addressData.address,
                landmark: addressData.landmark,
                address_as: addressData.address_as,
                country_code: countryCode,
                phone: cleanedNumber,
                latitude: latitude,
                longitude: longitude,
                google_address: await HandleGetGoogleAddress(latitude, longitude),
                instruction: addressData.instruction
            };

            // console.log(Data);

            axios.post(`${ApiBaseUrl}/customer/add_address`, Data)
                .then((res) => {
                    if (res.data.ResponseCode === 200) {
                        setIsLocationShow2("");
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    useEffect(() => {
        if (!paymentStatus) return;
        if (paymentStatus === "PaymentDone") {
            HandleBooking();
            setPaymentStatus("");
            setIsPayment(false);
        }
    }, [paymentStatus]);

    const HandleBooking = async () => {
        const Userid = secureLocalStorage.getItem("Userid");
        const PaymentId = sessionStorage.getItem("Paymentid");

        const TotalPrice = couponCode ? TotalAmt2 - couponCode.amt : TotalAmt2;

        if (Userid) {
            const Data = {
                id: Userid,
                lab_id: Labid,
                category_id: Categoryid,
                date: selectDate.format('DD-MM-YYYY'),
                time: SelectTime,
                message: additionalNote ? additionalNote : "",
                address: isDriverSelected2 ? selectAddress.id : "",
                package_list: await HandlePackageListGet(),
                family_mem_id: await HandleGetMemberIds(),
                tot_package_price: await HandleGetPackagePrice(productData),
                tot_price: TotalPrice,
                home_extra_price: isDriverSelected2 ? homeExteraPrice : 0,
                coupon_id: couponCode ? couponCode.id : "",
                coupon_amount: couponCode ? couponCode.amt : 0,
                site_commission: taxData.Rate,
                payment_id: PaymentId ? PaymentId : "",
                wallet_amount: isDriverSelected ? wallet : 0,
                home_col_status: isDriverSelected2 ? 1 : 0,
                transactionId: transactionid || "",
            };

            axios.post(`${ApiBaseUrl}/customer/add_lab_book`, Data)
                .then((res) => {
                    // console.log("add_lab_book", res);
                    const { message, ResponseCode } = res.data;
                    // console.log(res);
                    if (ResponseCode === 200) {
                        setIsPayment(false);
                        showToast({ title: message, id: "success" });
                        navigate("/booking-package");
                        setActivePage(3);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const HandleGetPackagePrice = (data) => {
        const totalSum = data.reduce((sum, item) => sum + item.total, 0);
        return totalSum;
    };

    return (
        <div className='width-container pb-[50px] lab-details'>

            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="">

                    <div className="flex items-center justify-between top-section">
                        <Link to="/" className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
                            <IoIosArrowBack className=' group-hover:text-white' />
                            <h1 className='font-[500] group-hover:text-white'> {t("Go Home")}</h1>
                        </Link>
                        <div className="flex items-center gap-[10px]">
                            <Link to="/packages" className='font-[500] text-gray-700'>{t("Packages")}</Link>
                            <IoIosArrowForward />
                            <h1 className='font-[500] text-gray-400 pagename'>{t("Cart Booking")}</h1>
                        </div>
                    </div>

                    <div className="book-section book-appointment">

                        <div className="width-box">

                            <div className="section-1">
                                <h1 className='font-[500] text-[18px]'>{t("Lab Details")}</h1>
                                <div className="border-[1px] border-[#8080803b] rounded-[10px] py-[10px] px-[15px] mt-[5px]">
                                    <div className="flex items-center gap-[10px]">
                                        <ImageLoad src={ImgBaseUrl + labData?.logo} CustomeStyle={"w-[100px] h-[100px] object-cover rounded-[10px] border-[1px] border-[#8080803b]"} alt={"logo"} />
                                        <div>
                                            <h1 className='font-[500] text-[18px]'>{labData?.name}</h1>
                                            <p className='text-gray-900'>{labData?.address}</p>
                                            <div className="flex items-center gap-[10px]">
                                                <FaStar className='text-orange-400' />
                                                <h1 className='font-[500] ' >{labData?.avg_star}</h1>
                                                <h1 className='text-gray-500'>({labData?.tot_review}+ Rating)</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="section-3">
                                <h1 className='font-[500] text-[18px]'>{t("Test Details & Package Details")}</h1>
                                <div className="">
                                    {packageData?.map((item, Index) => {
                                        const PatientLength = productData[Index]?.f;
                                        return <div key={Index} className="border-[1px] border-[#8080803b] rounded-[10px] py-[10px] px-[15px] mt-[5px]">
                                            <div className="flex items-start justify-between gap-[10px]">
                                                <div className="w-full flex items-start gap-[15px] overflow-hidden">
                                                    <ImageLoad src={ImgBaseUrl + item.logo} CustomeStyle={"border-[2px] border-[#80808073] rounded-[10px] h-[50px] object-contain w-[50px]"} alt={"logo"} />
                                                    <div className="w-full overflow-hidden">
                                                        <h1 className='font-[500] text-[18px] whitespace-nowrap overflow-ellipsis overflow-hidden'>{item.title}</h1>
                                                        <p className='text-gray-900'>{item.subtitle}</p>
                                                        <span className='text-gray-500 font-[500]'>{t("Includes")} {item.package_name} {t("tests")}</span>
                                                        <div className="flex items-center justify-between">
                                                            <h1 className='font-[500] text-[17px]'>{t("Package Price")} : <span className='text-gray-500'>{currency} {item.package_price} </span> X <span className='text-gray-500'>{PatientLength?.length}</span> </h1>
                                                            <h1 className='font-[500] text-[17px]'>{currency} {productData[Index]?.total}.0</h1>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button onClick={() => { setShowDeleteBox(item.id); setDeleteText(item.title) }}><img src={DeleteIcon} className='min-w-[25px]' alt="" /></button>
                                            </div>
                                            <div className="patient-list">
                                                <Swiper
                                                    slidesPerView={"auto"}
                                                    spaceBetween={10}
                                                    modules={[Pagination]}
                                                    className="mySwiper">
                                                    <SwiperSlide onClick={() => setIsPatient(true)} className="add-box"><LuPlus /></SwiperSlide>
                                                    {familyData?.map((item2, index) => {
                                                        const isSelected = productData[Index]?.f.includes(item2.id);
                                                        return (
                                                            <SwiperSlide key={index}
                                                                onClick={() => SelectPatientHandle(item2.id, item.package_price, item.id)}
                                                                className="patient-box text-center cursor-pointer relative overflow-visible"
                                                            >
                                                                <ImageLoad src={ImgBaseUrl + item2.profile_image} CustomeStyle={`patient-img ${isSelected ? "border-[3px] border-[#4038FF]" : ""}`} alt={"patient img"} />
                                                                {isSelected && (
                                                                    <div className="absolute right-[5px] bottom-[28px] p-[2px] rounded-[50px] bg-white">
                                                                        <div className="bg-[#4038FF] rounded-[50px] p-[2px]">
                                                                            <IoCheckmark className="text-white" />
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <h1 className="font-[500] text-[18px]">{item2.name}</h1>
                                                            </SwiperSlide>
                                                        );
                                                    })}
                                                </Swiper>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>

                        </div>

                        <div className="width-box">

                            <div style={{ margin: "0" }} className="section-2">
                                <h1 className='font-[500] text-[18px]'>{t("Select Sample Collection Slot")}</h1>
                                <div className="flex items-center gap-[20px] mt-[5px]">
                                    <button onClick={() => setIsShowDate(true)} className="w-[100%] font-[500] justify-center flex items-center gap-[20px] border-[1px] border-[#8080803b] p-[8px] rounded-[10px]">
                                        <img src={calendar} alt="" />
                                        <h1 className={selectDate && "text-[#4038FF]"} >{selectDate ? selectDate.format("DD-MM-YYYY") : t("Select Date")}</h1>
                                    </button>
                                    <button onClick={() => setOpenPicker(true)} className="w-[100%] font-[500] justify-center flex items-center gap-[20px] border-[1px] border-[#8080803b] p-[8px] rounded-[10px]">
                                        <img src={clock} alt="" />
                                        <h1 className={SelectTime && "text-[#4038FF]"} >{SelectTime ? SelectTime : t("Select Time")}</h1>
                                    </button>
                                </div>
                                <div className="hidden">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <MobileTimePicker
                                            label="Pick-Up Time"
                                            value={SelectTime ? dayjs(SelectTime, 'hh:mm A') : dayjs()}
                                            onChange={handleStartTimeChange}
                                            ampm
                                            open={openPicker}
                                            onClose={() => setOpenPicker(false)}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </div>

                            <div className="section-4 mt-[10px]">
                                <h1 className='font-[500] text-[18px]'>{t("Symptoms / Private Note")}</h1>
                                <textarea maxLength={500} onChange={(e) => setAdditionalNote(e.target.value)} className='textarea focus-within:border-[#4038FF] border-[2px] border-[#8080803b]' placeholder={t('Message')}></textarea>
                            </div>

                            {myWallet !== 0 && <div className="section-5">
                                <div className="flex items-center justify-between mb-[10px]">
                                    <h1 className='title'>{t("Pay from Wallet")}</h1>
                                    <label className="switch2">
                                        <input type="checkbox" checked={isDriverSelected} onChange={toggleDriverSelection} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="border-[1px] border-[#8080803b] py-[10px] px-[5px] rounded-[10px] flex items-center justify-between">
                                    <div className="flex items-center gap-[5px]">
                                        <img src={Wallet} alt="" />
                                        <h1 className='font-[500] text-[16px]'>{t("My Wallet")}</h1>
                                    </div>
                                    <h1 className='title text-[#4038FF]'>{currency}{isDriverSelected ? Number(myWallet2).toFixed(0) : Number(myWallet).toFixed(0)}.00</h1>
                                </div>
                            </div>}

                            <div className="section-6">
                                <div className="flex items-center justify-between border-b-[1px] pb-[10px] border-[#8080803b]">
                                    <div className="flex items-center gap-[5px]">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="#4038FF" stroke="none" ><path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path></svg>
                                        <div className="">
                                            <h1 className='title text-[#4038FF]'>{t("Apply Coupon")}</h1>
                                            {couponCode && <span className='text-[16px]'>{t("Use Code")} : <span className='font-[500]'>{couponCode.code}</span></span>}
                                        </div>
                                    </div>
                                    <button onClick={HandleCoupanRemove} className={`font-[500] ${couponCode ? "text-red-500" : "text-[#4038FF]"} text-[18px]`}>{couponCode ? t("Remove") : t("Apply")}</button>
                                </div>
                                <div onClick={() => !couponCode && setIsCouponShow(true)} className="flex items-center justify-between py-[10px] cursor-pointer">
                                    <h1 className=' text-gray-400 text-[16px]'>{t("View All Coupons")}</h1>
                                    <LuChevronRight className='text-gray-400 text-[20px]' />
                                </div>
                            </div>

                            {homeExteraPrice !== "0" && <div className="">
                                <div className="section-2">
                                    <h1>{t("Home Service (Collect my test sample)")}</h1>
                                    <div className="flex items-center justify-between">
                                        <h1 className='text-[#4038FF]'>{t("Additional Cost Required to Pay")} {currency}{homeExteraPrice}</h1>
                                        <label className="switch2">
                                            <input type="checkbox" checked={isDriverSelected2} onChange={() => setIsDriverSelected2(!isDriverSelected2)} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>

                                <div className="section-2">
                                    {isDriverSelected2
                                        ? <div className="flex items-center justify-between">
                                            <div className="">
                                                <h1 className='font-[500] text-[18px]'>{selectAddress ? selectAddress.address : t("We Come to You")}</h1>
                                                <p>{t("Choose your address for hassle-free sample collection at home")}</p>
                                            </div>
                                            <button onClick={() => setIsLocationShow(true)} className="flex items-center gap-[5px] border-[1px] border-[#8080803b] px-[10px] py-[6px] rounded-[8px]">
                                                <FiMapPin className='text-[20px] text-[#4038FF]' />
                                                <IoChevronDown className='text-[20px] text-[#4038FF]' />
                                            </button>
                                        </div>
                                        : <div className="">
                                            <div className="mb-[5px]">
                                                <h1 className='font-[500] text-[18px]'>{t("Your Lab Appointment Location")}</h1>
                                                <p>{t("Kindly visit the address below for your scheduled lab services.")}</p>
                                            </div>
                                            <div className="border-t-[2px] border-dashed border-[#8080803b] pt-[5px]">
                                                <p className='flex items-center gap-[5px]'><FiMapPin className='text-[20px] text-[#4038FF]' />{labData?.address}</p>
                                            </div>
                                        </div>}
                                </div>
                            </div>}

                            <div className="section-7">
                                <h1 className='title'>{t("Review Your Requirements for This Request")}</h1>
                                <div className="data">
                                    <h1 className='text-gray-700 text-[16px]'>{t("Service Total")}</h1>
                                    <h1 className='font-[500] text-[16px]'>{serviceTotal}.00{currency}</h1>
                                </div>

                                {isDriverSelected && <div className="data">
                                    <h1 className='text-gray-700 text-[16px]'>{t("Wallet")}</h1>
                                    <h1 className='font-[500] text-[16px]'>-{wallet}.00{currency}</h1>
                                </div>}

                                {couponCode && <div className="data">
                                    <h1 className='text-gray-700 text-[16px]'>{t("Coupon")}</h1>
                                    <h1 className='font-[500] text-[16px]'>-{couponCode.amt}{currency}</h1>
                                </div>}

                                {isDriverSelected2 && <div className="data">
                                    <h1 className='text-gray-700 text-[16px]'>{t("Home Collection Free")}</h1>
                                    <h1 className='font-[500] text-[16px]'>+{homeExteraPrice}.00{currency}</h1>
                                </div>}

                                <div className="data">
                                    <h1 className='text-gray-700 text-[16px]'>{t("Service Fee & Tax")} ({taxData?.type})</h1>
                                    <h1 className='font-[500] text-[16px]'>+{taxData?.Rate}.0{currency}</h1>
                                </div>

                                <div className="flex items-center justify-between mt-[5px]">
                                    <h1 className='text-[16px] font-[500]'>{t("Total Payable Amount")}</h1>
                                    <h1 className='font-[500] text-[16px]'>{TotalAmt}.00{currency}</h1>
                                </div>
                            </div>
                        </div>

                        <div className="btn-box">
                            <div className="flex items-center justify-between mt-[20px]">
                                <div className="">
                                    <h1 className='title'>{currency}{TotalAmt}.00</h1>
                                    <span className='text-[#4038FF]'>{t("View Detailed Bill")}</span>
                                </div>
                                <button onClick={HandleProceed} className='bg-[#4038FF] text-white font-[500] text-[16px] min-w-[200px] py-[5px] rounded-[5px]'>{t("Proceed")}</button>
                            </div>
                        </div>
                    </div>
                </div>}

            {isPatient && <div onClick={() => setIsPatient(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]'>
                <div onClick={(e) => e.stopPropagation()} className="add-patient">
                    <AddPatient Relation={relationshipData} BooldType={booldData} />
                </div>
            </div>}

            {isShowDate && <div onClick={() => setIsShowDate(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]'>
                <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-[10px]">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateCalendar
                            value={selectDate ? selectDate : today}
                            shouldDisableDate={disablePastDates}
                            onChange={(newDate) => { setSelectDate(newDate); setIsShowDate(false); }}
                        />
                    </LocalizationProvider>
                    <div className="flex items-center justify-end gap-[20px] px-[20px] text-[#4038FF] font-[500] pb-[10px]">
                        <button onClick={() => setIsShowDate(false)} >CANCEL</button>
                        <button onClick={() => { setIsShowDate(false); !selectDate && setSelectDate(today) }}>OK</button>
                    </div>
                </div>
            </div>}

            {isCouponShow && <div onClick={() => setIsCouponShow(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]'>
                <div onClick={(e) => e.stopPropagation()} className="add-patient max-h-[700px] overflow-hidden scroll-container" style={{ borderRadius: "10px" }}>
                    <h1 className='font-[500] text-[18px] mb-[5px]'>{t("Best Coupon")}</h1>
                    {couponList.map((item, index) => {
                        return <div key={index} className="border-[1px] rounded-[10px] p-[10px] border-[#8080803b] mb-[5px] flex items-center justify-between">
                            <div className="">
                                <div className="leading-[20px]">
                                    <h1 className='font-[500] text-[20px]'>{item.title}</h1>
                                    <p className='text-gray-500'>{item.sub_title}</p>
                                </div>
                                <div className="mt-[10px]">
                                    <h1>{t("Coupon Code")}: <span className='text-[#4038FF] font-[500]'>{item.code}</span></h1>
                                    <h1>{t("Coupon Amount")}: <span className='font-[500]'>{currency}{item.discount_amount}</span></h1>
                                    <h1>{t("Minimum Amount")}: <span className='font-[500]'>{currency}{item.min_amount}</span></h1>
                                    <h1>{t("Ex Date")}: <span className='font-[500]'>{item.end_date}</span></h1>
                                </div>

                                <button disabled={TotalAmt < item.min_amount && true} onClick={() => HandleCoupanAdd(item.code, item.discount_amount, item.id)} className={` ${TotalAmt > item.min_amount ? "coupon-btnAct" : "coupon-btnDic"}`} >{t("Apply Coupon")}</button>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="#ff8000" stroke="none" ><path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path></svg>
                        </div>
                    })}
                </div>
            </div>}

            {showDeleteBox && <div onClick={() => setShowDeleteBox("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bg-white p-[15px] rounded-[10px]">
                    <h1 className='font-[500] text-[18px]'>{t("Remove Cart?")}</h1>
                    <p className='text-gray-500 leading-[18px]'>{t("Are You Sure You Want To Delete All Items")} <br />  From {deletetext} </p>
                    <div className="flex items-center gap-[15px] justify-end mt-[10px]">
                        <button onClick={() => setShowDeleteBox("")} className='py-[4px] px-[20px] border-[1px] border-[#4038FF] text-[#4038FF] font-[500] rounded-[10px]'>{t("Cancel")}</button>
                        <button onClick={() => HandleBook(showDeleteBox)} className='py-[5px] px-[20px] bg-[#4038FF] text-white rounded-[10px] font-[500]'>{t("Remove")}</button>
                    </div>
                </div>
            </div>}

            {isLocationShow && <div onClick={() => setIsLocationShow("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bg-white p-[10px] rounded-t-[10px] min-w-[20%]">
                    <h1 className='font-[500] text-[18px]'>{t("Choose a Delivery Address")}</h1>
                    <button onClick={() => { setIsLocationShow2(true); setIsLocationShow("") }} className="flex items-center gap-[10px] mb-[10px]">
                        <FiPlus className='text-[30px] text-[#4038FF] border-[1px] border-[#4038FF] rounded-[5px] py-[5px] min-w-[40px]' />
                        <h1 className='font-[500] text-[18px] text-[#4038FF]'>{t("Add New Address")}</h1>
                    </button>
                    <div className="max-h-[400px] scroll-container">
                        {addressList.length >= 1
                            ? addressList.map((ietm, index) => {
                                return <div onClick={() => { setSelectAddress({ address: ietm.address, id: ietm.id }); setIsLocationShow("") }} key={index} className="border-[1px] border-[#8080803b] rounded-[10px] py-[5px] px-[10px] mt-[5px] cursor-pointer">
                                    <h1 className='font-[500] text-[18px]'>{ietm.address_as} {t("Address")}</h1>
                                    <div className="flex items-center gap-[5px]">
                                        <IoCallOutline className='text-green-500 text-[22px]' />
                                        <h1 className='font-[500] text-[16px] text-gray-500'>{ietm.country_code} {ietm.phone}</h1>
                                    </div>
                                    <div className="flex items-center gap-[5px]">
                                        <TiLocation className='text-[#4038FF] text-[22px]' />
                                        <h1 className='font-[500] text-[16px]'>{ietm.address}</h1>
                                    </div>
                                </div>
                            })
                            : <div className="h-[300px] flex items-center justify-center">
                                <h1 className='font-[500] text-[18px]'>{t("Add New Address")}</h1>
                            </div>
                        }
                    </div>
                </div>
            </div>}

            {isLocationShow2 && <div onClick={() => setIsLocationShow2("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box google-map scroll-container">
                    {isLoaded && <GoogleMap
                        center={{ lat: latitude, lng: longitude }}
                        zoom={15}
                        onClick={handleMapClick}
                    >
                        <Marker position={{ lat: latitude, lng: longitude }} />
                    </GoogleMap>}
                    <div className="mt-[10px]">
                        <div className="h-[120px]">
                            <textarea onChange={(e) => setAddressData({ ...addressData, address: e.target.value })} name="" className='min-h-[100%] max-h-[100%] w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#4038FF]' placeholder='Complete address' id=""></textarea>
                        </div>
                        <div className="mt-[5px]">
                            <input onChange={(e) => setAddressData({ ...addressData, houseno: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#4038FF]' type="text" placeholder='House no' />
                        </div>
                        <div className="mt-[5px]">
                            <div className="border-[2px] border-[#8080803b] focus-within:border-[#534cfe] rounded-[10px] p-[10px]">
                                <PhoneInput
                                    className="w-[100%]"
                                    international
                                    defaultCountry="IN"
                                    value={value}
                                    onChange={setValue}
                                    name="phone"
                                />
                            </div>
                        </div>
                        <div className="mt-[5px]">
                            <input onChange={(e) => setAddressData({ ...addressData, landmark: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#4038FF]' type="text" placeholder='Landmark' />
                        </div>
                        <div className="h-[120px] mt-[5px]">
                            <textarea onChange={(e) => setAddressData({ ...addressData, instruction: e.target.value })} className='min-h-[100%] max-h-[100%] w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#4038FF]' placeholder='How to rech instructions (Optional)' id=""></textarea>
                        </div>
                        <div className="mt-[10px]">
                            <h1 className='font-[500] text-[18px] mb-[5px]'>{t("Save Address As")}</h1>
                            <input onChange={(e) => setAddressData({ ...addressData, address_as: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none rounded-[10px] p-[10px] focus-within:border-[#4038FF]' type="text" placeholder='Eg: Home, Store' />
                        </div>
                    </div>
                    <button onClick={HandleSaveAddress} className='payment-btn mt-[10px]'>{t("Save Address")}</button>
                </div>
            </div>}

            {isPayment && <div onClick={() => setIsPayment(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="bottme-box">
                    <h1 className='font-[500] text-[20px]'>{t("Select Payment Method")}</h1>
                    <Payment Amount={TotalAmt} Data={allData} />
                </div>
            </div>}
        </div>
    )
}

export default CartBooking
/* jshint ignore:end */